// Single source of the App Store URL, with Apple campaign tracking (funnel
// audit R10). Every surface passes its own `ct` (campaign token) so the
// web→store hand-off is countable per-surface in App Store Connect → Analytics
// → Sources → Campaigns, for free.
//
// NOTE: Apple only attributes campaigns when BOTH `pt` (the ASC provider
// token) AND `ct` are present. Tom supplied the token from a generated
// campaign link 2026-07-24 — attribution shows up in App Store Connect →
// Analytics → Sources → Campaigns, one row per `ct` surface below.
const APP_ID = 'id6760759274';
const PROVIDER_TOKEN = '128599380'; // ASC provider token (R10, Tom 2026-07-24)

/**
 * @param {string} ct per-surface campaign token, e.g. 'web_locked_card',
 *   'web_banner', 'web_save_chain', 'web_profile'
 */
export function appStoreUrl(ct) {
  const base = `https://apps.apple.com/app/predict-six/${APP_ID}`;
  const params = new URLSearchParams();
  if (PROVIDER_TOKEN) params.set('pt', PROVIDER_TOKEN);
  if (ct) params.set('ct', ct);
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}
